import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ["option", "order_type", "address", "table", "submit", "delivery_fee", "delivery_amount", "discount_amount", "tip_amount", "total", "tax", "order_item", "unit_price", "tax_rate", "qty", "subtotal", "custom_fee_amount", "items", "empty_state", "header_actions"]

	connect() {
		this.selectFulfillment()

		this.element.addEventListener("recalculate-total", () => {
			this.calculateTotal();
		});

		// Rows arrive/leave three ways (custom-item template, product_add response, remove/hide),
		// so watch the items container instead of wiring every path by hand.
		if (this.hasItemsTarget) {
			this.itemsObserver = new MutationObserver(() => this.calculateTotal())
			this.itemsObserver.observe(this.itemsTarget, { childList: true, subtree: true, attributes: true, attributeFilter: ["style"] })
		}
	}

	disconnect() {
		if (this.itemsObserver) this.itemsObserver.disconnect()
	}

	selectFulfillment(event) {
		if (this.order_typeTarget.value == "table_service") {
			this.addressTarget.classList.add("hidden");
			this.tableTarget.classList.remove("hidden");
			this.delivery_feeTarget.classList.add("hidden");
		} else if (this.order_typeTarget.value == "delivery" || this.order_typeTarget.value == "dispatch") {
			this.tableTarget.classList.add("hidden");
			this.addressTarget.classList.remove("hidden");
			this.delivery_feeTarget.classList.remove("hidden");
		} else {
			this.addressTarget.classList.add("hidden");
			this.tableTarget.classList.add("hidden");
			this.delivery_feeTarget.classList.add("hidden");
		}

		this.calculateTotal()
	}

	calculateTotal(event) {
		// Paid orders render no item rows (and no items container): keep the server-side totals.
		if (!this.hasItemsTarget) return

		let tax = 0
		let tax_by_product = 0
		let subtotal = 0

		// Existing rows flagged for deletion are hidden rather than removed – leave them out.
		const rows = this.order_itemTargets.filter((el) => el.style.display != "none")

		rows.forEach((el) => {
			let unit_price = Number(el.querySelector('[data-target="pos.unit_price"]').value)
			let qty = Number(el.querySelector('[data-target="pos.qty"]').value)
			let tax_rate = Number(el.querySelector('[data-target="pos.tax_rate"]').value)
			let price = unit_price * qty
			let item_tax = unit_price * (tax_rate * 0.01) * qty

			if (el.getAttribute('data-price-including-tax') == "false")
				tax_by_product += item_tax

			tax += item_tax
			subtotal += price
		});

		// Totals used to be written inside the loop, so an order with no rows kept stale figures.
		let customFee = 0;
		if (this.hasCustom_fee_amountTarget)
			customFee = Number(this.custom_fee_amountTarget.value)

		let total = subtotal + Number(this.tip_amountTarget.value) - Number(this.discount_amountTarget.value) + (tax_by_product > 0 ? tax_by_product : 0) + customFee
		if (this.order_typeTarget.value == "delivery")
			total += Number(this.delivery_amountTarget.value)

		this.totalTarget.innerText = total.toFixed(2)
		this.subtotalTarget.innerText = subtotal.toFixed(2)
		this.taxTarget.innerText = tax_by_product > 0 ? tax_by_product.toFixed(2) : tax.toFixed(2)

		if (tax_by_product > 0) {
			document.getElementById("subtotal").classList.remove("hidden");
			document.getElementById("tax-title").innerHTML = "Tax"
		} else {
			document.getElementById("subtotal").classList.add("hidden");
			document.getElementById("tax-title").innerHTML = "Tax incl."
		}

		this.toggleEmptyState(rows.length)
	}

	toggleEmptyState(visibleRows) {
		if (this.hasEmpty_stateTarget) this.empty_stateTarget.classList.toggle("hidden", visibleRows > 0)
		if (this.hasHeader_actionsTarget) this.header_actionsTarget.classList.toggle("hidden", visibleRows == 0)
	}
}
